import React from 'react';
import StickySidebar from 'components/shared/StickySidebar';
import { useDraggable } from '@dnd-kit/core';
import ContentOption from './ContentOption';

const DraggableItem = ({ option }) => {
  const { attributes, listeners, setNodeRef } = useDraggable({
    id: option.id,
    data: {
      option,
      fromSidebar: true,
    },
  });

  return (
    <div ref={setNodeRef} {...listeners} {...attributes}>
      <ContentOption option={option} />
    </div>
  );
};

const Sidebar = ({ elements }) => {
  return (
    <StickySidebar className="JourneyBuilderSidebar">
      <div className="JourneyBuilderSidebar-header">
        {t('journeys.builder.build')}
      </div>
      {elements.map(option => (
        <DraggableItem key={option.id} option={option} />
      ))}
    </StickySidebar>
  );
};

export default Sidebar;
